import PerseidsFooter from './PerseidsFooter';

export default PerseidsFooter;
